import { PickerOptionsSection } from '../store/schema/CompositePickerInterfaces';
import CompositePickerStore from '../store/schema/CompositePickerStore';
import { action } from 'satcheljs';

export const updateFilteredOptions = action(
    'updateFilteredOptions',
    (viewState: CompositePickerStore, options: PickerOptionsSection[]) => ({
        viewState,
        options,
    })
);

export const resetFilteredOptions = action(
    'resetFilteredOptions',
    (viewState: CompositePickerStore) => ({ viewState })
);
